import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { BRANCHES, fmtDate, mapLink, toKey } from "@/lib/format";

const KINDS = [["setup", "🔧 MONTAGEM"], ["event", "🎉 EVENTO"], ["teardown", "📦 DESMONTAGEM"]];

export const buildDayMessage = (events, day, branch = "all") => {
  const items = [];
  events.forEach((ev) => {
    const acts = KINDS.filter(([k]) => ev[`${k}_date`] === day).map(([k, label]) => ({ label, time: ev[`${k}_time`] || "" }));
    if (acts.length) items.push({ ev, acts, time: acts[0].time });
  });
  items.sort((a, b) => (a.time || "99").localeCompare(b.time || "99"));
  const head = `*Floor LED 360${BRANCHES[branch] ? ` · Filial ${BRANCHES[branch]}` : ""} — Programação de ${fmtDate(day, "EEEE, dd/MM/yyyy")}*`;
  if (!items.length) return `${head}\n\nNenhuma montagem, evento ou desmontagem neste dia.`;
  const body = items.map(({ ev, acts }) => [
    acts.map(({ label, time }) => `${label}${time ? ` · ${time}` : ""}`).join("\n"),
    `*${ev.title}*${branch === "all" && BRANCHES[ev.branch] ? ` (${BRANCHES[ev.branch]})` : ""}`,
    `📍 ${[ev.location, ev.address].filter(Boolean).join(" — ")}`,
    `🗺️ ${mapLink(ev)}`,
    ev.equipment.length ? `🎛️ ${ev.equipment.map((e) => `${e.quantity}x ${e.name}`).join(", ")}` : "",
    ev.responsible_name || ev.responsible_phone ? `👤 ${[ev.responsible_name, ev.responsible_phone].filter(Boolean).join(" · ")}` : "",
    `🔗 ${window.location.origin}/evento/${ev.id}`,
  ].filter(Boolean).join("\n")).join("\n\n");
  return `${head}\n\n${body}`;
};

export const ShareDayButton = ({ events, branch }) => {
  const [day, setDay] = useState(toKey(new Date()));
  const send = () => window.open(`https://wa.me/?text=${encodeURIComponent(buildDayMessage(events, day, branch))}`, "_blank", "noopener");

  return (
    <div data-testid="share-day-container" className="flex items-stretch overflow-hidden rounded-sm border border-emerald-600/50">
      <input type="date" data-testid="share-day-date-input" value={day} onChange={(e) => setDay(e.target.value)}
        className="h-10 bg-slate-900/60 px-3 font-mono text-xs text-slate-200 outline-none [color-scheme:dark]" />
      <button data-testid="share-day-whatsapp-button" onClick={send} disabled={!day}
        className="inline-flex flex-1 items-center justify-center gap-2 bg-emerald-600 px-4 text-sm font-semibold text-white transition-colors hover:bg-emerald-500 disabled:opacity-50">
        <MessageCircle size={16} /><span className="whitespace-nowrap">Enviar dia no WhatsApp</span>
      </button>
    </div>
  );
};
